module.exports = __webpack_public_path__ + "img/vendor.b8a76337.svg";